import { Collapse, Row, Col } from 'antd';
import React from 'react';
import { CaretRightOutlined } from '@ant-design/icons';
import Title from 'components/Title';
import { TpAuthorizationResponse } from 'services/thirdParty';
import FormInput from 'components/FormInput';
import SaveButton from 'components/SaveButton';
import { useHistory } from 'react-router-dom';

const { Panel } = Collapse;

export type ActivitiesSFSProps = {
  id: number;
  tpauthlist: TpAuthorizationResponse[];
};

const ActivitiesSFS = ({ id, tpauthlist }: ActivitiesSFSProps) => {
  const history = useHistory();

  let tpAuthList = tpauthlist?.filter((tp) => tp.authstatus === 'ACTIVE');

  let tpAuthDetails = tpAuthList?.flatMap((tp) => tp.authDetail);

  return (
    <>
      <Collapse
        bordered={false}
        expandIcon={({ isActive }) => (
          <CaretRightOutlined
            style={{ fontSize: 24, float: 'left' }}
            rotate={isActive ? 90 : 0}
          />
        )}
        expandIconPosition="start"
        defaultActiveKey={['1']}
      >
        {tpAuthDetails?.map((auth, index) => {
          let startdate = auth.startdate !== null ? 'Du ' + auth.startdate : '';
          let enddate = auth.startdate !== null ? ' au ' + auth.enddate : '';

          return (
            <Panel
              header={<Title level={5} comcode={auth.offerlabel}></Title>}
              key={auth.authdetailid}
              style={{
                marginBottom: 24,
                background: '#f7f7f7',
                border: 10,
                borderRadius: 2,
                boxShadow:
                  'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
              }}
            >
              <Row gutter={16}>
                <Col span={4}>
                  <Row style={{ marginBottom: '5%' }}>
                    <Col xs={24}>
                      <FormInput name="Produits SVN" initialValue="OUI" />
                    </Col>
                  </Row>
                  <Row style={{ marginBottom: '5%' }}>
                    <Col xs={24}>
                      <FormInput name="Produit X" initialValue="NON" />
                    </Col>
                  </Row>
                  <Row style={{ marginBottom: '5%' }}>
                    <Col xs={24}>
                      <FormInput name="Produit Y" initialValue="NON" />
                    </Col>
                  </Row>
                </Col>
                <Col span={12}>
                  <Row
                    gutter={80}
                    style={{ marginBottom: '5%', marginLeft: '5%' }}
                  >
                    <Col xs={12}>
                      <FormInput
                        name="date"
                        initialValue={startdate + enddate}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Panel>
          );
        })}
      </Collapse>
      <Row gutter={12} justify="center">
        <Col span={!Number(id) ? 5 : 4}>
          <SaveButton
            comcode="Annuler"
            custom={{ height: 45 }}
            onClick={() => {}}
          />
        </Col>
        <Col span={!Number(id) ? 5 : 4}>
          <SaveButton
            comcode="Enregistrer"
            custom={{ height: 45 }}
            onClick={() => {}}
          />
        </Col>
      </Row>
    </>
  );
};

export default ActivitiesSFS;
